import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";

export const S_ADD_IBAN_POPUP = new Signal<{
	iban?: IIban;
	callback: (iban: IIban) => void;
} | null>("S_ADD_IBAN_POPUP");

export const AddIbanPopup = () => {
	useLocale();
	const requestData = S_ADD_IBAN_POPUP.use();
	const [busy, _setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [form, setForm] = useState<IIban>();

	useEffect(() => {
		if (requestData) {
			if (requestData.iban) {
				setForm({ ...requestData.iban });
			} else {
				setForm({
					iban: "",
					name: "",
				});
			}
		}
	}, [requestData]);

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (requestData && form) {
			requestData.callback(form);
			S_ADD_IBAN_POPUP.invoke(null);
		}
	};

	const closePopup = () => {
		S_ADD_IBAN_POPUP.invoke(null);
		setError(undefined);
		setForm(undefined);
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			busy={busy}
			label={requestData.iban ? msg("editIban") : msg("addNewIban")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "40px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				<Form
					data={form}
					decorator={[
						{
							direction: "column",
							fields: [
								{
									name: "name",
									label: msg("title"),
								},
								{
									name: "iban",
									label: "IBAN",
								},
							],
						},
					]}
				/>
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />
				<Button
					title={requestData.iban ? msg("save") : msg("add_9fd728c6")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
